import React from 'react'
import { useApp } from '../../../context/AppProvider'
import { isEmpty } from '../../../services/common'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'

const GeneralsInformations = ({ block, viewGeneralInformation, setViewGeneralInformation }) => {
    const { selectedValue } = useApp()
    return (
        <div>
            {viewGeneralInformation !== undefined ? (
                isEmpty(selectedValue) && (
                    <p
                        className="baseocom-cursor-pointer baseocom-fill-[color:var(--baseocom-color-purple)] baseocom-items-center baseocom-gap-3 !baseocom-text-[color:var(--baseocom-text-color-body)] baseocom-flex"
                        onClick={() => setViewGeneralInformation(true)}
                    >
                        {icon('arrow-right', '20')}
                        <span>
                            Accéder aux informations générales
                            <strong className="baseocom-ml-1"> sans renseigner la situation</strong>
                        </span>
                    </p>
                )
            ) : (
                <Parser content_block={block.childrens} />
            )}
        </div>
    )
}

export default GeneralsInformations
